import { ReportService } from 'services/ReportService';

const reportsService = new ReportService();

const getCategories = async () => {
    const body = {
        "columns_select": ["*"],
        "where_select": "*"
    }
    try {
        const response = await reportsService.category.getCategorys(body);
        return response
    } catch (error) {
        console.error(error);
        throw error;
    }
}

const createCategory = async (name: string) => {

    const data = {
        "object_add": {
            "name": name
        }
    }
    try {
        const response = await reportsService.category.createCategory(data);
        return response;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

const updateCategory = async (category_id: number, name: string) => {

    const category = {
        "columns_update": {
            "name": name
        },
        "where_update": {
            "id": category_id
        }
    }
    try {
        const response = await reportsService.category.updateCategory(category);
        return response;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export {
    getCategories,
    createCategory,
    updateCategory
};